// Textos de los ajustes de anuncios por zona (zone-ad-settings). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    ZONE_AD_SETTINGS: {
      TITLE: 'Ajustos d\'anuncis per zona',
      NOTE_TITLE: 'Esborranys d\'anuncis per a zones sense match',
      NOTE_TEXT:
        'Cada cert temps es busquen les rutines que fa temps que no tenen match i es prepara un esborrany d\'anunci a Meta per a la seva zona (una cel·la H3). Aquí es decideix quan es fa, amb quins valors neix cada esborrany i amb quines dades es publica.',
      LOADING: 'Carregant els ajustos…',
      ERROR_LOAD: 'No s\'han pogut carregar els ajustos d\'anuncis per zona.',
      ERROR_FORBIDDEN: 'No tens permís per veure els ajustos d\'anuncis per zona.',
      RETRY: 'Tornar-ho a provar',

      GENERAL_TITLE: 'Generació automàtica',
      GENERAL_SUB: 'Apagada, no es creen esborranys nous.',
      ENABLED_LABEL: 'Generar esborranys automàticament',

      GENERATION_TITLE: 'Quines zones hi entren',
      GENERATION_SUB: 'Mida de la zona i quines rutines i zones es tenen en compte a cada generació.',
      H3_RESOLUTION: 'Resolució H3',
      H3_RESOLUTION_HINT: 'Mida de la cel·la de cada zona, de 0 (la més gran) a 15 (la més petita).',
      NO_MATCH_HOURS: 'Hores sense match',
      NO_MATCH_HOURS_HINT: 'Hores que ha de portar una rutina sense match per comptar, d\'1 a 87.600.',
      COOLDOWN_DAYS: 'Dies d\'espera per zona',
      COOLDOWN_DAYS_HINT: 'Dies que espera una zona, després de tancar-se el seu últim esborrany, abans de rebre\'n un altre. De 0 a 365.',
      SCHEDULE_LABEL: 'Quan es genera',
      SCHEDULE_TIMES: 'A hores fixes',
      SCHEDULE_EVERY: 'Cada N hores',
      EVERY_HOURS_LABEL: 'Interval',
      EVERY_HOURS_ONE: 'Cada hora',
      EVERY_HOURS_OTHER: 'Cada {{count}} hores',
      TIME_ARIA: 'Hora {{n}}',
      ADD_TIME: 'Afegir hora',
      REMOVE_TIME: 'Treure aquesta hora',
      SCHEDULE_HINT: 'Hora de Madrid.',

      DEFAULTS_TITLE: 'Valors de cada esborrany',
      DEFAULTS_SUB: 'Amb aquests valors neix cada esborrany generat.',
      RADIUS_KM: 'Radi (km)',
      RADIUS_KM_HINT: 'Radi de l\'anunci, d\'1 a 80 km.',
      BUDGET: 'Pressupost (€)',
      BUDGET_HINT: 'Pressupost total de la campanya.',
      DURATION_DAYS: 'Durada (dies)',
      DURATION_DAYS_HINT: 'Dies que dura la campanya, d\'1 a 90.',
      BUDGET_MINIMUM: 'Amb aquests valors, el pressupost ha de ser com a mínim de {{min}} (mínim de Meta per plataforma i dia × 2 plataformes × dies).',
      ADVANTAGE_DEFAULT: 'Audiència Advantage+ per defecte als esborranys nous',
      ADVANTAGE_HINT: 'Meta pot ampliar l’edat i els interessos per millorar el rendiment; la zona continua sent un límit. Cada esborrany es pot canviar mentre és esborrany.',

      META_TITLE: 'Publicació a Meta',
      META_SUB: 'Dades que s\'envien a Meta amb cada anunci.',
      DSA_MISSING: 'Sense pagador i beneficiari no es pot publicar cap esborrany a Meta.',
      LANDING_URL: 'Pàgina de destinació',
      LANDING_URL_HINT: 'On porta l\'anunci. Ha de començar per https://',
      DSA_PAYOR: 'Pagador (DSA)',
      DSA_PAYOR_HINT: 'Qui paga els anuncis, segons la Llei de Serveis Digitals de la UE.',
      DSA_BENEFICIARY: 'Beneficiari (DSA)',
      DSA_BENEFICIARY_HINT: 'En nom de qui s\'anuncia.',
      MIN_BUDGET_PER_DAY: 'Pressupost mínim de Meta per plataforma i dia (€)',
      MIN_BUDGET_PER_DAY_HINT: 'El que exigeix Meta a cada conjunt d’anuncis (Facebook i Instagram) per dia.',

      UPDATED_AT: 'Última modificació',
      SAVE: 'Desar els canvis',
      SAVING: 'Desant…',
      SAVE_DISABLED_HINT: 'Revisa els camps marcats per poder desar',
      SAVED: 'Ajustos desats',
      ERROR_SAVE: 'No s\'han pogut desar els ajustos',
      ERROR_FORBIDDEN_SAVE: 'No tens permís per canviar els ajustos d\'anuncis per zona',
      ACCEPT: 'Acceptar',

      VALIDATION: {
        REQUIRED: 'Aquest camp és obligatori.',
        INTEGER: 'Ha de ser un nombre enter.',
        RANGE: 'Ha d\'estar entre {{min}} i {{max}}.',
        MIN_BUDGET: 'El mínim és {{min}}.',
        MAX_BUDGET: 'El màxim és {{max}}.',
        EURO_CENTS: 'Com a molt dos decimals.',
        HTTPS_URL: 'Ha de ser una adreça que comenci per https://',
        MAX_LENGTH: 'Com a molt {{max}} caràcters.',
        TIMES_REQUIRED: 'Afegeix almenys una hora.',
        TIME_FORMAT: 'Format HH:MM.',
      },
    },
  },
};
